import React, { Component } from "react";
import PickerEvent from "./PickerEvent";

export default class WheelPicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      valueGroups: {
        title: "운행문의",
      },
      optionGroups: {
        title: [
          "운행문의",
          "정산문의",
          "앱 사용자 불편 신고",
          "기타",
          "가입문의",
          "등록문의",
          "네트워크 오류",
          "네비게이션 오류",
        ],
      },
    };
  }

  handleChange = (name, value) => {
    this.setState(({ valueGroups }) => ({
      valueGroups: {
        ...valueGroups,
        [name]: value,
      },
    }));
  };

  render() {
    const { optionGroups, valueGroups } = this.state;
    this.props.onSelect(valueGroups.title);

    return (
      <div className={"wheel_picker"}>
        <PickerEvent
          optionGroups={optionGroups}
          valueGroups={valueGroups}
          onChange={this.handleChange}
        />
      </div>
    );
  }
}
